import { Configuration, Dashboard, Events, Payments, Plans, Suscriptions } from './Children';

// TODO: Add scopes
export const StripeConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'openPayGroup',
      path: 'open-pay',
      children: [
        {
          id: 'openPayGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          id: 'openPayGroup.payments',
          path: 'payments',
          element: <Payments />,
        },
        {
          id: 'openPayGroup.suscriptions',
          path: 'suscriptions',
          element: <Suscriptions />,
        },
        {
          id: 'openPayGroup.plans',
          path: 'plans',
          element: <Plans />,
        },
        {
          id: 'openPayGroup.events',
          path: 'events',
          element: <Events />,
        },
        {
          id: 'openPayGroup.configuration',
          path: 'configuration',
          element: <Configuration />,
        },
      ],
    },
  ],
};
